// extracted by mini-css-extract-plugin
module.exports = {"BooksTextInput":"BooksTextInput_BooksTextInput__dbe6t","isSetValue":"BooksTextInput_isSetValue__1IkCr"};